import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: "¿Esto funciona para los 'terribles dos'?",
    a: 'Sí, es la herramienta principal para esa etapa. Te ayudará a entender exactamente qué está pasando en su cerebro durante estos años cruciales.'
  }, {
    q: '¿Tengo que leerlo todo de una vez?',
    a: 'No, está diseñado para que consultes el capítulo exacto de la edad de tu hijo. Es un manual de consulta rápida para momentos de crisis.'
  }, {
    q: '¿Es un libro físico?',
    a: 'Es un producto digital (PDF) de acceso inmediato. Podrás leerlo en tu celular, tablet o computadora al instante de tu compra.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-cream" data-id="element-14">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-15">
        <FadeIn data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brown mb-12" data-id="element-17">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-19">
              <div className="bg-white rounded-2xl border border-cream-dark overflow-hidden transition-all duration-300" data-id="element-20">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-21">
                  <span className="font-bold text-brown text-lg pr-8" data-id="element-22">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-terracotta transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-23" />
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-24">
                  <p className="text-brown-light leading-relaxed" data-id="element-25">{faq.a}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}